import React from "react";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { store, persistor } from "./reduxStore/store";

import AppRoutes from "./routes";

const App = () => (
  <div>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
          <AppRoutes />
        </MuiPickersUtilsProvider>
      </PersistGate>
    </Provider>
  </div>
);

export default App;
